export default {"src":"/_next/static/media/location_white.1ceeb68d.svg","height":15,"width":15};